﻿// future: support many storage strategies
import $ from 'jquery';
import { Storage } from "./storage";
import { Element } from "./element";

declare global {
  interface JQuery {
    eventlistener: (option, args) => any;
  }
}

export class EventListener {
  public static get wireup(): string { return this.attributeKey.asDataSelector(); }
  public static get attributeKey(): string { return 'event-listener'; }

  private DEFAULTS: IEventListenerOptions = {
    eventListener: null,
    eventListenerBinding: 'value',
    eventListenerEmptyMessage: 'Not Entered'
  };

  private $element: JQuery;
  private options: IEventListenerOptions;

  public constructor($element: JQuery, options: IEventListenerOptions) {
    if ($element.length <= 0)
      throw new Error('$element cannot be null');

    this.$element = $element;
    this.options = $.extend({}, this.DEFAULTS, $element.data(), options);

    if (!this.options.eventListener)
      throw new Error('eventListener cannot be null');
    if (!this.options.eventListenerBinding)
      throw new Error('eventListenerBinding cannot be null');

    Storage.setChangeListener(this.options.eventListener, this.setText.bind(this));
  }

  public setText(key: string): void {
    let storageValue = Storage.get(key);

    let element = new Element(this.$element);
    if (storageValue && storageValue[this.options.eventListenerBinding])
      element.text(storageValue[this.options.eventListenerBinding]);
    else
      element.text(this.options.eventListenerEmptyMessage);

    element.$.trigger('notified.rustig.eventlistener');
  }
}

export interface IEventListenerOptions {
  eventListener: string;
  eventListenerBinding: string;
  eventListenerEmptyMessage: string;
}

function Plugin(option, args) {
  return this.each(function () {
    var $this = $(this);
    var data = $this.data('rustig.eventlistener');
    var options = typeof option == 'object' && option;

    if (!data) {
      data = new EventListener($this, options);
      $this.data('rustig.eventlistener', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.eventlistener = Plugin;
